import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import UserAppResource from "./UserAppResource";
import ServiceProviderCallToActionAppResource from "./ServiceProviderCallToActionAppResource";
import ServiceProviderMessageAppResource from "./ServiceProviderMessageAppResource";
import ServiceProviderReferralTypeAppResource from "./ServiceProviderReferralTypeAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";
import ServiceProviderJotformRequestAppResource from "./ServiceProviderJotformRequestAppResource";

class ServiceProviderReferralLogAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-referral-log';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/referrals/logs';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'serviceProviderUuid',
            'serviceProviderContactUuid',
            'userUuid',
            'hubUuid',
            'messageUuid',
            'typeUuid',
            'serviceTypeUuid',
            'websiteLink',
            'ctaLabel',
            'ctaUrl',
            'jotformRequestUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            serviceProvider: ServiceProviderAppResource,
            serviceProviderContact: ServiceProviderContactAppResource,
            user: UserAppResource,
            hub: WorkspaceAppResource,
            message: ServiceProviderMessageAppResource,
            type: ServiceProviderReferralTypeAppResource,
            serviceType: ServiceProviderTypeAppResource,
            jotformRequest: ServiceProviderJotformRequestAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            serviceProvider: 'service_provider_uuid',
            serviceProviderContact: 'service_provider_contact_uuid',
            user: 'user_uuid',
            hub: 'hub_uuid',
            message: 'message_uuid',
            type: 'type_uuid',
            serviceType: 'service_type_uuid',
            jotformRequest: 'jotform_request_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            serviceProviderUuid: {
                type: 'string',
                presence: true,
            },
            serviceProviderContactUuid: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            hubUuid: {
                type: 'string',
                presence: true,
            },
            messageUuid: {
                type: 'string',
            },
            typeUuid: {
                type: 'string',
                presence: true,
            },
            serviceTypeUuid: {
                type: 'string',
                presence: true,
            },
            ctaLabel: {
                type: 'string',
            },
            ctaUrl: {
                type: 'string',
            },
            jotformRequestUuid: {
                type: 'string',
            },
        };
    }
}

export default ServiceProviderReferralLogAppResource;
